import React from 'react'
import './notFound.css'
import illustration_Error from '../../assets/images/illustration_Error @1x.png'

export default class Index extends React.Component {
    render() {
        return (
            <div className="notfound-container">
                <div className="opps">OPPS!</div>
                <div className="page-not-found">Page Not Found</div>
                <div className="we-cant-seem-to-fin">We can&apos;t seem to find the page you are looking for</div>
                <div className="illustration_Error">
                    <img alt="illustration_Error" src={illustration_Error} />
                </div>
            </div>
        )
    }
}
